import {Button, Form} from 'react-bootstrap';
import { useState } from 'react';
import '../styles/login.css'
import PasswordChecklist from "react-password-checklist";

function RegisterForm({
    newName,
    newUsername,
    newEmail,
    newPhoneNumber,
    newPassword,
    setNewName,
    setNewUsername,
    setNewEmail,
    setNewPhoneNumber,
    setNewPassword,
    changeAuthMode,
    handleRegister
}) {
    const [message, setMessage] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [password, setPassword] = useState("");

    const handleInputChange = (event) => {
      const value = event.target.value;
  
      if (/^\d*$/.test(value)) {
        setMobileNumber(value);
  
        // Regular expression to match exactly 10 digits
        const regex = /^\d{10}$/;
        if (value.length === 0 || regex.test(value)) {
          setMessage(value.length === 10 ? '' : '');
        } else {
          setMessage('Mobile number must be exactly 10 digits.');
        }
      } else {
        setMessage('Only digits are allowed.');
      }
    }

    return (
        <>
            <div className='login-section'>
                <Form>
                    <Form.Group className='mb-3' controlId='formBasicNameSignup'>
                        <Form.Label>Full name</Form.Label>
                        <Form.Control value={newName} onChange={(e) => setNewName(e.target.value)} type='name' placeholder='Enter name' />
                        <Form.Text className='text-muted'>
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className='mb-3' controlId='formBasicEmaillSignup'>
                        <Form.Label>Email address</Form.Label>
                        <Form.Control value={newEmail} onChange={(e) => setNewEmail(e.target.value)} type='email' placeholder='Enter email' />
                        <Form.Text className='text-muted'>
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className='mb-3' controlId='formBasicPhoneNumberSignup'>
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control value={newPhoneNumber} onChange={(e) => {setNewPhoneNumber(e.target.value); handleInputChange(e)}} maxLength='10' minLength='10' type='phoneNumber' placeholder='Enter phone number' />
                        <Form.Text className='text-muted'>
                        </Form.Text>
                        {message && (
                            <p style={{ color: 'red' }}>
                            {message}
                            </p>
                        )}
                    </Form.Group>

                    <Form.Group className='mb-3' controlId='formBasicUsernamelSignup'>
                        <Form.Label>Username</Form.Label>
                        <Form.Control value={newUsername} onChange={(e) => setNewUsername(e.target.value)} type='username' placeholder='Enter username' />
                        <Form.Text className='text-muted'>
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className='mb-3' controlId='formBasicPasswordSignup'>
                        <Form.Label>Password</Form.Label>
                        <Form.Control value={newPassword} onChange={(e) => { setNewPassword(e.target.value); setPassword(e.target.value) }} type='password' placeholder='Password' />
                    </Form.Group>
                    <PasswordChecklist
                        rules={[
                            "minLength",
                            "specialChar",
                            "number",
                            "capital",
                        ]}
                        minLength={8}
                        value={password}
                    />
                    <div style={{padding: '25px 0 10px 0'}}>
                    Already have an account?  
                    <Button className='anchor-button' style={{paddingTop: '2px'}} onClick={changeAuthMode}>Sign in</Button>
                    </div>
                    
                </Form>
                <Button onClick={handleRegister} variant='primary'>Create Account</Button>
            </div>
        </>       
    );

}

export default RegisterForm;